import policyholderDetails from './policyholder-details.en'
import professionalInfo from './professional-info.en'
import quoteRequestStepper from './quote-request-stepper.en'
import declarations from './declarations.en'
import quoteList from './quote-list.en'
import dashboard from './dashboard.en'
import drsLounge from './drs-lounge.en'
import summaryAndPayment from './summary-and-payment.en'
import paymentResult from './payment-result.en'
import policyRenewal from './policy-renewal.en'
import quoteExpiredPopup from './quote-expired-popup.en'
import faq from './faq.en'
import cancellation from './cancellation.en'
import iban from './iban.en'
import ehsan from './ehsan.en'
import policyDocument from './policy-document.en'
import receipt from './receipt.en'

export default {
  policyholderDetails,
  professionalInfo,
  quoteRequestStepper,
  declarations,
  quoteList,
  dashboard,
  drsLounge,
  summaryAndPayment,
  paymentResult,
  policyRenewal,
  quoteExpiredPopup,
  faq,
  cancellation,
  iban,
  ehsan,
  policyDocument,
  receipt,
} as const

export { default as drsLounge } from './drs-lounge.en'
